import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowAltCircleLeft, faBan, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { AnnotationNavigationButton } from '../../../../modules/common/annotationNavigationButton/AnnotationNavigationButton';
import { EditorMode } from '../../../../modules/editor/models/EditorModes';
import { ValidSaveIcon } from '../../../components/icons/ValidSaveIcon';
import { RequestClarificationButtonContainer } from '../submodules/clarifications/containers/RequestClarificationButton.container';
import { DiscardAnnotationConfirmationModal } from './DiscardAnnotationConfirmationModal';
import { QuitAnnotationsModal } from './QuitAnnotationsModal';

library.add(faArrowAltCircleLeft, faCheckCircle, faTimesCircle, faBan);

interface ICorrectionNavigationComponentProps {
  onSubmitAndAccept: () => Promise<void>;
  onReject: () => Promise<void>;
  onCancel: () => Promise<void>;
  onCancelCancel: () => void;
  onConfirmCancel: () => Promise<void>;
  onDiscardConfirmed: () => Promise<void>;
  onDiscardCanceled: () => void;
  onDiscard: () => void;
  showDiscardModal: boolean;
  disabled: boolean;
  showCancelModal: boolean;
  canDiscard: boolean;
  editorMode: EditorMode;
}

export const CorrectNavigation = observer((props: ICorrectionNavigationComponentProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='annotation-navigation correct'>
      <AnnotationNavigationButton
        size='md'
        id='submit-annotation'
        loaderKey='submit-and-accept-button'
        disabled={props.disabled}
        onClick={props.onSubmitAndAccept}
        title={t('submit_and_Accept_tooltip')}
        startDecorator={<ValidSaveIcon />}
      >
        {t('submit_and_accept')}
      </AnnotationNavigationButton>
      <AnnotationNavigationButton
        size='md'
        color='danger'
        loaderKey='reject-button'
        disabled={props.disabled}
        onClick={props.onReject}
        title={t('reject_tooltip')}
        startDecorator={<FontAwesomeIcon icon={faTimesCircle} />}
      >
        {t('reject')}
      </AnnotationNavigationButton>
      {props.canDiscard && (
        <AnnotationNavigationButton
          size='md'
          color='neutral'
          variant='outlined'
          id='discard-annotation'
          loaderKey='discard-annotation-button'
          disabled={props.disabled}
          onClick={props.onDiscard}
          title={t('discard_tooltip')}
          startDecorator={<FontAwesomeIcon icon={faBan} />}
        >
          {t('discard')}
        </AnnotationNavigationButton>
      )}
      <DiscardAnnotationConfirmationModal
        showDiscardModal={props.showDiscardModal}
        onDiscardCancel={props.onDiscardCanceled}
        onDiscardConfirm={props.onDiscardConfirmed}
      />
      <QuitAnnotationsModal
        isOpen={props.showCancelModal}
        onCancel={props.onCancelCancel}
        onConfirm={props.onConfirmCancel}
      />
      <RequestClarificationButtonContainer
        disabled={props.disabled}
        editorMode={props.editorMode}
      />

      <AnnotationNavigationButton
        size='md'
        color='neutral'
        variant='outlined'
        loaderKey='cancel-annotation-button'
        disabled={props.disabled}
        onClick={props.onCancel}
        title={t('cancel_correct_tooltip')}
        startDecorator={<FontAwesomeIcon icon={faArrowAltCircleLeft} />}
      >
        {t('cancel')}
      </AnnotationNavigationButton>
    </div>
  );
});
